<template>
	<div class="page">
		<div class="page-header">
			<img v-if="bannerImage" class="page-header__banner" :src="bannerImage" alt="banner">
			<img v-else class="page-header__banner" src="~@/assets/images/school-banner.png" alt="banner">
			<div class="page-header__bd">
				<el-row type="flex">
					<img class="school-logo" v-if="school.logo" :src="school.logo">
					<div style="flex: 1;">
						<div class="">
							<h1 class="page-name">{{ infos.schoolName }}</h1>
							<span class="school-tag" @click="schoolHref()">院校官网</span>
							<span class="school-tag" @click="recruitHref()">招生章程</span>
              <span class="school-tag" @click="vrHref()">全景探校</span>
						</div>
						<el-row type="flex" style="margin-top: 23px;">
							<div style="flex: 1;">
                <div>
                  <div v-for="item in collegeLevel2Array" class="detail-tag">
                    <span>{{ item.label }}</span>
                  </div>
                </div>
                <div>
                  <span class="detail-tag">{{ school.schoolSort }}</span>
                  <span v-if="school.rateGraduate" class="detail-tag">保研率：{{ school.rateGraduate }}</span>
                </div>
							</div>
							<el-row type="flex" align="middle" style="flex-shrink: 0; margin-bottom: 18px">
								<span @click="toggleCollectStatus" class="collect">
									<i :class="`collect-icon el-icon-star-${collect.isCollect ? 'on' : 'off'}`"></i>
									<span class="collect-text">收藏</span>
								</span>
								<el-dropdown trigger="click">
									<el-button type="primary">
										<span style="margin-right: 10px;">收藏列表</span>
										<i class="el-icon-caret-bottom"></i>
									</el-button>
									<el-dropdown-menu class="modify-dropdown" slot="dropdown">
										<el-dropdown-item v-for="item in collect.list" :key="item.id">
											<el-row type="flex" align="middle" style="min-width: 89px;">
												<span @click="goDetails(item)" style="flex: 1; margin-right: 10px;">{{ item.name }}</span>
												<i @click.stop="onCancelCollectItem(item)" style="flex-shrink: 0; line-height: 1;" class="el-icon-delete"></i>
											</el-row>
										</el-dropdown-item>
										<el-dropdown-item v-if="collect.list.length === 0">暂无数据</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<el-button @click="goSchoolDiff" style="margin-left: 18px;" type="primary">院校对比</el-button>
							</el-row>
						</el-row>
						<span class="school-address">{{ school.schoolAddress }}</span>
					</div>
				</el-row>

			</div>
		</div>
		<div class="page-bd">
      <el-tabs class="ui-tabs" v-model="tabs.active" style="flex: 1; min-width: 0;">
        <el-tab-pane v-for="item in tabs.list" :key="item.id" :label="item.label" :name="item.prop">
					<template v-if="item.prop === 'graduate'">
						<div class="graduate-panel">
							<div class="graduate-kpis">
                <div class="kpi">
                  <div class="label">专业总数</div>
                  <div class="value">{{ graduate.totalNum }}</div>
                </div>
								<div class="kpi">
									<div class="label">硕士点总数</div>
									<div class="value">{{ graduate.totalSNum }}</div>
								</div>
								<div class="kpi">
									<div class="label">博士点总数</div>
									<div class="value">{{ graduate.totalBNum }}</div>
								</div>
							</div>
							<div class="coverage">
								<span class="coverage-caption">硕士 / 博士点覆盖占专业总数的比例</span>
								<div class="bar">
									<div class="m" :style="{ width: graduateCoverage.masterShare }"></div>
									<div class="d" :style="{ width: graduateCoverage.doctorShare }"></div>
								</div>
								<div class="bar-legend">
									<span><i class="dot m"></i>硕士点覆盖 <b>{{ graduateCoverage.master }}</b>（{{ graduateCoverage.masterPct }}）</span>
									<span><i class="dot d"></i>博士点覆盖 <b>{{ graduateCoverage.doctor }}</b>（{{ graduateCoverage.doctorPct }}）</span>
								</div>
							</div>
							<div class="graduate-legend">
								图例：
								<span class="chip master">硕士专业</span>
								<span class="chip doctor">博士专业</span>
								<span class="chip none">无博士点</span>
								<input class="graduate-search" v-model="graduate.keyword" type="search" placeholder="输入专业名称关键字">
							</div>
							<template v-for="group in filteredGraduateGroups">
								<div class="catsec" :key="group.cateName">
									<h3>{{ group.cateName }}（{{ group.count }}个专业）</h3>
									<div v-for="sub in group.types" :key="sub.majorType">
										<div class="catsub"><h4>{{ sub.majorType }}</h4></div>
										<div class="tablebox">
											<table>
												<thead>
													<tr><th>专业名称</th><th>硕士专业</th><th>博士专业</th></tr>
												</thead>
												<tbody>
													<tr v-for="row in sub.rows" :key="row.id">
														<td class="major">{{ row.majorName }}</td>
														<td class="masters">
															<div class="chips">
																<span class="chip master" v-for="name in row.sNameList" :key="name">{{ name }}</span>
																<span class="chip none" v-if="!row.sNameList || row.sNameList.length === 0">—</span>
															</div>
														</td>
														<td class="doctors">
															<div class="chips">
																<span class="chip doctor" v-for="name in row.bNameList" :key="name">{{ name }}</span>
																<span class="chip none" v-if="!row.bNameList || row.bNameList.length === 0">—</span>
															</div>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</template>
							<div class="empty" v-if="filteredGraduateGroups.length === 0">没有匹配的专业</div>
						</div>
					</template>
					<template v-else-if="item.prop === 'majorRate'">
						<div class="rate-panel" v-loading="rate.loading">
							<!-- 届别索引 -->
							<div class="rate-years" v-if="rate.sessionList.length">
								<button
									v-for="s in rate.sessionList"
									:key="s"
									type="button"
									class="rate-year-chip"
									:class="{ 'is-active': s === rate.session }"
									@click="selectRateSession(s)"
								>{{ s }}</button>
							</div>
							<!-- 检索工具条 -->
							<div class="rate-toolbar">
								<span class="rate-toolbar__caption">院校整体保研率 <em class="rate-toolbar__value">{{ rate.schoolRate }}</em></span>
								<div class="rate-search">
									<i class="el-icon-search rate-search__icon"></i>
									<input class="rate-search__input" v-model="rate.keyword" type="search" placeholder="检索专业名称">
								</div>
							</div>
							<!-- 学院分组列表 -->
							<div class="rate-table" v-if="filteredRateColleges.length">
								<div class="rate-table__head">
									<span>学院</span>
									<span>学院保研率</span>
									<span>专业保研率</span>
								</div>
								<article
									class="rate-college"
									v-for="row in filteredRateColleges"
									:key="row.index"
								>
									<div class="rate-college__row">
										<div class="rate-college__name"><strong>{{ row.college.college }}</strong></div>
										<div class="rate-college__rate">
											<span class="rate-major__rate">{{ row.college.collegeRate }}</span>
										</div>
										<div class="rate-college__majors">
											<template v-if="row.college.majorList && row.college.majorList.length">
												<span class="major-count"></span>
												<button type="button" class="expand-button" @click="toggleRateCollege(row.index)">
													<span>{{ rateCollapsed[row.index] ? '展开专业' : '收起专业' }}</span>
													<i :class="rateCollapsed[row.index] ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
												</button>
											</template>
										</div>
									</div>
									<div class="rate-majors" v-show="!rateCollapsed[row.index] && row.college.majorList && row.college.majorList.length">
										<div class="rate-major" v-for="(m, mi) in row.college.majorList" :key="mi">
											<span class="rate-major__name">{{ m.majorName }}</span>
											<span class="rate-major__rate">{{ m.majorRate }}</span>
										</div>
									</div>
								</article>
							</div>
							<div class="rate-empty" v-else-if="!rate.loading">
								{{ rate.keyword ? '没有找到匹配的专业' : '暂无保研率数据' }}
							</div>
						</div>
					</template>
					<div v-else v-html="school[item.prop]" class="article-content"></div>
        </el-tab-pane>
      </el-tabs>


			<!-- <div class="ui-title">
				<div class="ui-title__icon"></div>
				<div class="ui-title__name">师资力量与学科建设</div>
			</div>
			<div v-html="school.teachers" class="ui-article"></div>
			<div class="ui-title">
				<div class="ui-title__icon"></div>
				<div class="ui-title__name">就业升学</div>
			</div>
			<div v-html="school.employment" class="ui-article"></div>
			<div class="ui-title">
				<div class="ui-title__icon"></div>
				<div class="ui-title__name">校内选拔、转专业、辅修学位</div>
			</div>
			<div v-html="school.selection" class="ui-article"></div> -->
		</div>
	</div>
</template>

<script>
import { request } from "@/util/request.js"
export default {
	components: {},
	data() {
		return {
			bannerImage: null,
			tabs: {
				list: [
					{ label: '院校介绍', prop: 'introduce' },
					{ label: '历史沿革', prop: 'history' },
					{ label: '师资力量', prop: 'teachers' },
					{ label: '学科建设', prop: 'subjects' },
					{ label: '教学管理', prop: 'selection' },
					{ label: '教学设施', prop: 'facilities' },
					{ label: '就业升学', prop: 'jobStudy' },
					{ label: '专业保研率', prop: 'majorRate' },
					{ label: '硕博点概览', prop: 'graduate' },
				],
				active: 'introduce',
			},
			details: [],
			father: [],
			score: [],
			category: [],
			graduate: {
				totalSNum: 0,
				totalBNum: 0,
				totalNum: 0,
				list: [],
				keyword: '',
			},
			// 专业保研率（按学院分组）
			rate: {
				loading: false,
				schoolName: '',
				schoolRate: '',
				session: '',
				sessionList: [],
				collegeList: [],
				keyword: '',
			},
			// 学院专业列表的收起状态（key 为学院在原列表中的下标）
			rateCollapsed: {},
			id: '',
			infos: {},
			school:{},

			collect: {
				list: [],
				isCollect: false,
			},
		}
	},
	created() {
		this.infos = this.$route.params.info
		this.infos = JSON.parse(localStorage.getItem('infos'))
		document.title=this.infos.schoolName+"介绍"
		this.getBanner()
		this.getSchoolIntroduction()
		this.getSchoolGraduate()
		this.getCollectList()
	},
	computed: {
    collegeLevel2Array() {
      let result = new Array();
      if(this.school.nature){
        let natures = this.school.nature.split(",")
        let natureArray = this.$constants.schoolNatureList.filter(item => natures.includes(item.value) > 0);
        natureArray.forEach((item) => {
          result.push(item);
        });
      }
      result.push({"value": this.school.schoolType,"label": this.school.schoolType});
      if(this.school.collegeLevel){
        let ids = this.school.collegeLevel.split(',');
        let collegeLevelArray = this.$constants.schoolCollegeLevel.filter(item => ids.includes(item.value) > 0);
        collegeLevelArray.forEach((item) => {
          result.push(item);
        });
      }
      if(this.school.qualifications){
        let qualifications = this.school.qualifications.split(",")
        let qualificationArray = this.$constants.schoolQualifications.filter(item => qualifications.includes(item.value) > 0);
        qualificationArray.forEach((item) => {
          result.push(item);
        });
      }
      result.push({"value": this.school.manager,"label": this.school.manager});

      // 院校层级
      return result
    },
    // 硕博点覆盖率统计
    graduateCoverage() {
      // sNameList / bNameList 是 list 里每个专业 row 上的字段，需遍历统计被覆盖的专业数
      let master = this.graduate.totalSNum
      let doctor = this.graduate.totalBNum
      // 专业总数以接口返回的 totalNum 为准，与上方 KPI 保持一致；无值时回退到列表行数
      const total = this.graduate.totalNum || this.graduate.list.length
      const pct = n => total ? (n / total * 100).toFixed(1) + '%' : '0%'
      // 条形宽度按硕、博覆盖数占两者之和的比例
      const sum = master + doctor
      const share = n => sum ? (n / sum * 100) + '%' : '0%'
      return {
        master,
        doctor,
        masterPct: pct(master),
        doctorPct: pct(doctor),
        masterShare: share(master),
        doctorShare: share(doctor),
      }
    },
    // 硕博点概览：按学科门类、专业类别分组
    graduateGroups() {
      const groups = []
      const groupMap = {}
      this.graduate.list.forEach(row => {
        const cateName = row.cateName || '其他'
        const majorType = row.majorType || '其他'
        if (!groupMap[cateName]) {
          groupMap[cateName] = { cateName, count: 0, types: [], typeMap: {} }
          groups.push(groupMap[cateName])
        }
        const group = groupMap[cateName]
        if (!group.typeMap[majorType]) {
          group.typeMap[majorType] = { majorType, rows: [] }
          group.types.push(group.typeMap[majorType])
        }
        group.typeMap[majorType].rows.push({
          id: row.id,
          majorName: row.majorName,
          sNameList: row.sNameList || row.snameList || [],
          bNameList: row.bNameList || row.bnameList || [],
        })
        group.count++
      })
      return groups
    },
    // 按专业名称关键字过滤后的分组
    filteredGraduateGroups() {
      const q = this.graduate.keyword.trim()
      if (!q) return this.graduateGroups
      const groups = []
      this.graduateGroups.forEach(group => {
        const types = []
        group.types.forEach(sub => {
          const rows = sub.rows.filter(row => row.majorName.indexOf(q) !== -1)
          if (rows.length) types.push({ majorType: sub.majorType, rows })
        })
        if (types.length) {
          const count = types.reduce((sum, sub) => sum + sub.rows.length, 0)
          groups.push({ cateName: group.cateName, count, types })
        }
      })
      return groups
    },
    // 专业保研率：按关键字过滤学院/专业（保留原始下标用于展开状态）
    filteredRateColleges() {
      const list = this.rate.collegeList || []
      const q = this.rate.keyword.trim()
      // 过滤掉无专业名称的占位项，保证“专业数量为 0”时不展示展开/收起按钮
      const validMajors = majors => (majors || []).filter(m => m && (m.majorName || '').trim())
      if (!q) {
        return list.map((college, index) => ({
          college: Object.assign({}, college, { majorList: validMajors(college.majorList) }),
          index
        }))
      }
      const result = []
      list.forEach((college, index) => {
        const majors = validMajors(college.majorList)
        const collegeMatch = (college.college || '').indexOf(q) !== -1
        const matched = collegeMatch
          ? majors
          : majors.filter(m => (m.majorName || '').indexOf(q) !== -1)
        if (collegeMatch || matched.length) {
          result.push({ college: Object.assign({}, college, { majorList: matched }), index })
        }
      })
      return result
    }
	},
	methods: {
		getBanner() {
			this.$api.queryBanner({ type: this.$constants.bannerTypes.school }).then(res => {
				if (![0, 200].includes(res.code)) {
					return this.$message.error(res.msg)
				}
				if (res.data[0]) {
					this.bannerImage = res.data[0].image
				}
			})
		},
		getSchoolIntroduction() {
			request({
				method: 'get',
				url: 'SchoolIntroduction/getSchoolDetailV2',
				params:{
					code: this.infos.code
				}
			}).then(res => {
				if (![0, 200].includes(res.code)) {
					return this.$message.error(res.msg)
				}
				this.school = res.data;
				document.title = res.data.schoolName + "介绍"
				this.getCollectListStatus()
				this.getSchoolRateGraduate()
			})
		},
		getSchoolGraduate() {
			request({
				method: 'get',
				url: 'SchoolIntroduction/getSchoolGraduate',
				params: {
					code: this.infos.code
				}
			}).then(res => {
				if (![0, 200].includes(res.code)) {
					return this.$message.error(res.msg)
				}
				this.graduate.totalNum = (res.data && res.data.totalNum) || 0
				this.graduate.totalSNum = (res.data && res.data.totalSNum) || 0
				this.graduate.totalBNum = (res.data && res.data.totalBNum) || 0
				this.graduate.list = (res.data && res.data.list) || []
			})
		},
		// 获取院校专业保研率（session 不传默认最新届别）
		getSchoolRateGraduate(session) {
			const schoolName = (this.school && this.school.schoolName) || this.infos.schoolName
			if (!schoolName) return
			this.rate.loading = true
			request({
				method: 'get',
				url: 'schoolRateGraduate/getRateBySchool',
				params: {
					schoolName,
					session: session || ''
				}
			}).then(res => {
				if (![0, 200].includes(res.code)) {
					return this.$message.error(res.msg)
				}
				const data = res.data || {}
				this.rate.schoolName = data.schoolName || schoolName
				this.rate.schoolRate = data.schoolRate || ''
				this.rate.session = data.session || ''
				this.rate.sessionList = data.sessionList || []
				this.rate.collegeList = data.collegeList || []
				// 切换届别后重置展开状态，默认全部展开
				this.rateCollapsed = {}
			}).finally(() => {
				this.rate.loading = false
			})
		},
		// 切换届别
		selectRateSession(session) {
			if (session === this.rate.session) return
			this.getSchoolRateGraduate(session)
		},
		// 展开/收起某学院的专业列表
		toggleRateCollege(index) {
			this.$set(this.rateCollapsed, index, !this.rateCollapsed[index])
		},
		schoolHref(){
			if(this.school.schoolHref === '' || this.school.schoolHref == null){
				this.$message({
						message: '未配置官网地址',
						type: 'error'
				});
			}else{
					window.open(this.school.schoolHref, '_blank');
			}
		},
		recruitHref(){
			if(this.school.recruitHref === '' || this.school.recruitHref == null){
				this.$message({
					message: '未配置招生章程地址',
					type: 'error'
				});
			}else{
				window.open(this.school.recruitHref, '_blank');
			}
		},
    vrHref(){
			if(this.school.vrHref === '' || this.school.vrHref == null){
				this.$message({
					message: '未配置全景探校地址',
					type: 'error'
				});
			}else{
				window.open(this.school.vrHref, '_blank');
			}
		},

		toggleCollectStatus() {
			if (this.collect.isCollect) {
				this.$store.dispatch('setCollectStatus', {
					action: 'cancel',
					params: [
						{ code: this.school.schoolCode, type: 1, }
					]
				}).then(res => {
					this.collect.isCollect = false
					this.getCollectList()
				})
			} else {
				this.$store.dispatch('setCollectStatus', {
					action: 'add',
					type: 1,
					code: this.school.schoolCode,
					name: this.school.schoolName
				}).then(res => {
					this.collect.isCollect = true
					this.getCollectList()
				})
			}
		},

		getCollectList() {
			this.$api.getCollectList({
				pageNum: 1,
				pageSize: 500,
				type: 1, // 收藏类型 1:学校 2:专业
			}).then(res => {
				if (![0, 200].includes(res.code)) {
					return this.$message.error(res.msg)
				}
				this.collect.list = res.data.list
			})
		},

		getCollectListStatus() {
			let userInfo = this.$store.getters.userInfo
			this.$api.isCollect({
				userId: userInfo.userId,
				code: this.school.schoolCode,
				type: 1, // 收藏类型 1:学校 2:专业
			}).then(res => {
				if (![0, 200].includes(res.code)) {
					return this.$message.error(res.msg)
				}
				this.collect.isCollect = res.data
			})
		},

		onCancelCollectItem(item) {
			this.$confirm(`确定删除该收藏？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				return this.$store.dispatch('setCollectStatus', {
					action: 'cancel',
					params: [
						{ code: item.code, type: 1, }
					]
				})
			}).then(res => {
				if (item.code === this.school.schoolCode) {
					this.collect.isCollect = false
				}
				this.getCollectList()
			})
		},

		goSchoolDiff() {
			const routeData = this.$router.push({
				path: '/schoolV2/schoolDiff',
				query: {
					code: this.school.schoolCode
				}
			})
			// window.open(routeData.href, '_blank')
		},
	},
}
</script>

<style lang="stylus" scoped>
.page
	font-size: 15px;
	background: #F9F9F9;
	&-bd
		width BodyMaxWidth
		margin 10px auto 60px auto
		uiBlock();
		padding 20px 22px 39px 22px
		box-sizing border-box
.page-header
	width: 100%;
	min-height: 260px;
	position relative
	&__banner
		width 100%
		height 100%
		object-fit: cover;
		position absolute
		top 0
		left 0
	&__bd
		position: relative;
		padding: 47px 17px 44px 17px;
		z-index: 1;
		width: BodyMaxWidth;
		margin: 0 auto;
		box-sizing: border-box;

.page-name
	display inline-flex
	margin 0px 28px 0 0
	font-size: 28px;
	font-weight: normal;
	color: #fff;
	line-height: 58px;
	text-shadow: 0px 4px 4px rgba(121, 68, 2, 0.1);

.article-content {
	margin 48px 0 48px 15px
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 24px;
}
.ui-tabs /deep/
	.el-tabs__item + .el-tabs__item
		margin-left 40px

.school-tag
	display inline-flex
	margin-right 10px
	padding 0 13px
	height: 28px;
	background: rgba(8, 8, 8, 0.2);
	border-radius: 6px;
	font-size: 14px;
	color: #FAFAFA;
	line-height: 28px;
	cursor pointer
.school-logo
	width 168px
	height 168px
	border-radius 4px
	margin-right 24px
	flex-shrink 0
	background #fff
	padding 15px
	box-sizing border-box
	object-fit cover
.school-address
	font-size: 14px;
	color: #FAFAFA;
	display block
	// margin-top 18px
.detail
	&-name
		margin 0 0 47px
		font-size: 50px;
		// font-family: Alimama FangYuanTi VF;
		font-weight: normal;
		color: #FFFFFF;
		line-height: 48px;
		text-shadow: 0px 4px 4px rgba(121,68,2,0.1);
	&-tag
		display inline-flex
		align-items center
		border-left: 1px solid #F9F9F9;
		box-sizing border-box
		font-size: 14px;
		font-weight: 400;
		color: #FAFAFA;
		padding 0 8px
		margin-bottom 18px
		&:first-child
			border-left none
			padding-left 0

.collect
	display flex
	align-items center
	color PrimaryColor
	margin-right 28px
	cursor pointer
	&-icon
		font-size 28px
		margin-right 8px
		text-align: center;
		display: inline-block;
	&-icon.el-icon-star-off
		font-size: 24px
	&-icon.el-icon-star-on
		font-size: 28px
	&-text
		font-size: 16px;
		font-weight: 400;

// 硕博点概览
.graduate-panel
	margin 24px 0 0
	font-size 14px
	color #1f2430
	.kpi
		background #fff
		border 1px solid #e2e5ea
		border-radius 10px
		padding 12px 14px
		.label
			font-size 12px
			color #6b7280
		.value
			font-size 22px
			font-weight 600
			margin-top 2px
	.graduate-kpis
		display grid
		grid-template-columns repeat(auto-fit, minmax(150px, 1fr))
		gap 10px
		margin-bottom 14px
	.coverage
		background #fff
		border 1px solid #e2e5ea
		border-radius 10px
		padding 12px 14px
		margin-bottom 12px
		font-size 13px
	.coverage-caption
		font-weight 700
	.bar
		display flex
		height 16px
		border-radius 8px
		overflow hidden
		margin-top 8px
		background #f1f2f4
		border 1px solid #e2e5ea
	.bar .m
		background PrimaryColor
	.bar .d
		background #3D7DC4
	.bar-legend
		display flex
		flex-wrap wrap
		gap 14px
		margin-top 8px
		font-size 12px
		color #6b7280
	.bar-legend .dot
		display inline-block
		width 10px
		height 10px
		border-radius 50%
		margin-right 4px
		vertical-align -1px
	.bar-legend .dot.m
		background PrimaryColor
	.bar-legend .dot.d
		background #3D7DC4
	.bar-legend b
		color #1f2430
		font-weight 600
	.graduate-legend
		display flex
		flex-wrap wrap
		gap 8px
		margin 12px 0
		font-size 12px
		color #6b7280
		align-items center
	.graduate-search
		margin-left auto
		padding 6px 10px
		border 1px solid #e2e5ea
		border-radius 8px
		background #fff
		color #1f2430
		font-size 13px
		min-width 200px
	.chip
		display inline-block
		padding 2px 9px
		border-radius 999px
		font-size 12px
		border 1px solid
		line-height 1.55
		white-space nowrap
	.chip.master
		background #FDE2D5
		border-color PrimaryColor
		color #7A3B22
	.chip.doctor
		background #EAF2FB
		border-color #3D7DC4
		color #24538C
	.chip.none
		background #f1f2f4
		border-color #c2c6cc
		color #8a9099
	.catsec
		margin 18px 0 8px
		h3
			font-size 18px
			margin 0 0 6px
			padding-bottom 6px
			border-bottom 2px solid #FF7D3A
			color #000
	.catsub
		margin 12px 0 4px
		h4
			font-size 14px
			margin 0 0 6px
			color #000
			font-weight 600
	.tablebox
		overflow-x auto
		background #fff
		border 1px solid #e2e5ea
		border-radius 10px
		margin-bottom 10px
	table
		border-collapse collapse
		width 100%
		min-width 780px
	th, td
		text-align left
		padding 8px 10px
		border-bottom 1px solid #e2e5ea
		vertical-align top
		font-size 13px
	th
		background #fff
		font-weight 700
	td.major
		font-weight 500
		width 22%
	td.masters, td.doctors
		width 39%
	.chips
		display flex
		flex-wrap wrap
		gap 4px
	.empty
		color #6b7280
		font-size 13px
		padding 10px

// 专业保研率
.rate-panel
	margin 24px 0 0
	font-size 14px
	color #1f2430
	.rate-years
		display flex
		flex-wrap wrap
		gap 8px
		margin 12px 0 0
		padding 12px 14px
		border 1px solid #e2e5ea
		border-radius 10px
		background #fff
	.rate-year-chip
		min-width 74px
		min-height 32px
		padding 0 12px
		border 1px solid #e2e5ea
		border-radius 8px
		background #fff
		color #6b7280
		font-size 13px
		cursor pointer
		transition all .15s ease
		&:hover
			border-color #BD4F18
			color #BD4F18
		&.is-active
			border-color #BD4F18
			background #BD4F18
			color #fff
	.rate-toolbar
		display flex
		align-items center
		gap 12px
		margin 18px 0 10px
		&__caption
			font-size 16px
			font-weight 600
			color #1f2430
		&__value
			font-style normal
			font-weight 600
			// 固定为 #BD4F18，避免运行时变量覆盖导致偏色
			color #BD4F18
			&.is-missing
				color #6b7280
		.rate-overall
			display flex
			align-items center
			gap 8px
			&__session
				color #1f2430
				font-size 13px
				font-weight 600
			&__label
				color #6b7280
				font-size 13px
			&__value
				color #BD4F18
				font-size 20px
				font-weight 600
				line-height 1
				&.is-missing
					color #6b7280
					font-size 14px
					font-weight 400
		.rate-search
			margin-left auto
			display flex
			align-items center
			min-width 220px
			padding 6px 10px
			border 1px solid #e2e5ea
			border-radius 8px
			background #fff
			&__icon
				margin-right 6px
				color #8a9099
				font-size 14px
			&__input
				flex 1
				min-width 0
				border 0
				background transparent
				color #1f2430
				font-size 13px
				&:focus
					outline none
			&:focus-within
				border-color PrimaryColor
	.rate-table
		border 1px solid #e2e5ea
		border-radius 10px
		overflow hidden
		background #fff
		&__head
			display grid
			grid-template-columns minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)
			align-items center
			gap 12px
			min-height 42px
			padding 0 20px
			border-bottom 1px solid #e2e5ea
			background #f5f7fa
			color #1f2430
			font-size 16px
			font-weight 600
	.rate-college
		& + .rate-college
			border-top 1px solid #e2e5ea
		&__row
			display grid
			grid-template-columns minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)
			align-items center
			gap 12px
			min-height 44px
			padding 6px 20px
			&:hover
				background #f7f8fa
		&__name strong
			font-size 14px
			font-weight 600
			color #1f2430
		.rate-chip
			display inline-flex
			align-items center
			justify-content center
			min-width 76px
			min-height 26px
			padding 2px 9px
			border 1px solid PrimaryColor
			border-radius 999px
			background #FDE2D5
			color #7A3B22
			font-size 13px
			font-weight 600
			&.is-missing
				border-color #c2c6cc
				background #f1f2f4
				color #8a9099
				font-weight 400
		&__majors
			display flex
			align-items center
			justify-content flex-end
			gap 12px
			.major-count
				color #6b7280
				font-size 13px
			.no-major
				color #6b7280
				font-size 13px
			.expand-button
				display inline-flex
				align-items center
				gap 6px
				min-height 30px
				padding 0 11px
				border 1px solid #e2e5ea
				border-radius 8px
				background #fff
				color #BD4F18
				font-size 12px
				font-weight 600
				cursor pointer
				&:hover
					border-color #BD4F18
					background #FDE2D5
	.rate-majors
		padding 0 20px
		background #f7f8fa
		border-top 1px dashed #e2e5ea
	.rate-major
		display grid
		grid-template-columns minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)
		align-items center
		gap 12px
		min-height 28px
		padding 6px 0
		border-bottom 1px dashed #e2e5ea
		&:last-child
			border-bottom 0
		&__name
			position relative
			padding-left 44px
			color #1f2430
			font-size 13px
			&::before
				content ""
				position absolute
				top 50%
				left 24px
				width 12px
				border-top 1px dashed #c2c6cc
		&__rate
			grid-column 3
			// 固定为 #BD4F18，避免运行时变量覆盖导致偏色
			color #BD4F18
			font-size 13px
			font-weight 600
			&.is-missing
				color #6b7280
				font-weight 400
	.rate-empty
		padding 24px 20px
		text-align center
		color #6b7280
		font-size 13px
</style>
